@import 'styles/variables';
@import 'styles/mixins';
@import 'styles/blaze/mixins';

.input {
  color: var(--neutral-90);
  background: var(--neutral-0);
  border-radius: 4px;
  caret-color: var(--selected-stroke);
  width: 100%;
  appearance: none;
  -webkit-appearance: none;

  &.withBorder {
    border-radius: 6px;
    background: var(--light-100);
    box-shadow: 1px 1px 0 0 var(--light-90) inset, 0 2px 12px 0 var(--dark-4);
    @include blur;
  }

  caret-color: var(--selected-fill);

  &::placeholder {
    color: var(--dark-40);
  }

  &.grey {
    background: var(--dark-4);
    color: var(--dark-80);
    border: 1px solid transparent;
    box-shadow: none;
  }

  &.focused {
    &.withBorder {
      box-shadow: inset 0 0 0 2px var(--selected-stroke);
      border: 1px solid transparent;
    }

    &.grey {
      background: var(--light-100);
    }
  }

  [data-autopilot-system-redesign='on'] & {
    caret-color: var(--dark-90);
    background: var(--light-100);
    border-radius: 8px;

    &.withBorder {
      @include blur(0);
      border: 1px solid var(--dark-8);
      box-shadow: none;

      &:hover {
        border: 1px solid var(--dark-15);
      }

      &.focused {
        border: 1px solid var(--dark-80);
      }
    }
  }
}

.invalid {
  background: var(--negative-5);
  caret-color: #ed847e;

  &.withBorder {
    box-shadow: inset 0 0 0 2px #ffbdb8;

    &.focused {
      box-shadow: inset 0 0 0 2px #ed847e;
    }
  }

  [data-autopilot-system-redesign='on'] & {
    background: var(--light-100);
    caret-color: var(--dark-90);

    &::placeholder {
      color: var(--dark-80);
    }

    &.withBorder {
      border: 1px solid var(--red-70);
      box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.05);

      &.focused {
        box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.05);
      }
    }
  }
}

.xs {
  @include xs-sohne-book;
  padding: 6px 8px;

  [data-autopilot-system-redesign='on'] & {
    @include sm-sohne;
    min-height: 28px;
    height: 28px;
    border-radius: 6px;
    padding: 4px 6px;
    line-height: 130%; /* 18.2px */
    letter-spacing: 0.14px;
  }
}

.sm {
  @include sm-sohne;
  padding: 6px 8px;

  [data-autopilot-system-redesign='on'] & {
    @include sm-sohne;
    min-height: 28px;
    height: 28px;
    border-radius: 6px;
    padding: 4px 6px;
    line-height: 130%; /* 18.2px */
    letter-spacing: 0.14px;
  }
}

.md {
  @include md-sohne;
  padding: 6px 10px;

  [data-autopilot-system-redesign='on'] & {
    @include sm-sohne;
    min-height: 32px;
    height: 32px;
    border-radius: 8px;
    padding: 8px;
    line-height: 130%; /* 18.2px */
    letter-spacing: 0.14px;

    @include for-phone-only {
      height: 40px;
      min-height: 40px;
      padding: 10px 12px;
    }
  }
}

.lg {
  @include md-sohne;
  padding: 9px 10px;
  border-radius: 8px;

  [data-autopilot-system-redesign='on'] & {
    @include md-sohne;
    min-height: 36px;
    height: 36px;
    border-radius: 8px;
    padding: 8px;
    line-height: 145%; /* 23.2px */
    letter-spacing: 0.16px;

    @include for-phone-only {
      height: 44px;
      min-height: 44px;
      padding: 10px 12px;
    }
  }
}

// Wizard ArrayInput (TagInput for links, etc.): not a single-line field — fixed .lg height clips it.
.input.tagArrayInputWrapper.lg {
  [data-autopilot-system-redesign='on'] & {
    height: auto;
    min-height: 36px;
    overflow: visible;

    @include for-phone-only {
      min-height: 44px;
    }
  }
}

.xl {
  @include md-sohne;
  padding: 12px 15px;
  border-radius: 10px;

  [data-autopilot-system-redesign='on'] & {
    @include md-sohne;
    height: 48px;
    min-height: 48px;
    border-radius: 10px;
    padding: 12px 15px;
    line-height: 145%; /* 23.2px */
    letter-spacing: 0.16px;
  }
}

.xxl {
  @include lg-sohne;
  padding: 12px 16px;
  border-radius: 8px;

  [data-autopilot-system-redesign='on'] & {
    @include md-sohne;
    border-radius: 10px;
    padding: 12px 15px;
    line-height: 145%; /* 23.2px */
    letter-spacing: 0.16px;
  }
}

.textarea {
  @include hide-scrollbar;
  @include scroll-behavior-smooth;
  resize: none;

  [data-autopilot-system-redesign='on'] & {
    height: unset;
    min-height: unset;
  }
}

.errorMessage {
  @include sm-sohne;
  color: var(--negative-50);

  [data-autopilot-system-redesign='on'] & {
    color: var(--red-70);
  }
}

.validMessage {
  @include sm-sohne;
  color: var(--positive-50);
}

.disableScroll {
  overflow: hidden;
}

@media (min-width: $phoneMaxWidth) {
  .input {
    &.withBorder {
      box-shadow: none;
      border: 1px solid var(--dark-15);
    }

    &.grey {
      border-color: transparent;
    }
  }
}
